export const TEXT = {
  FOUR_O_FOUR: '404',
  BROKEN_MSG: "Oops! We couldn't find the page you are looking for.",
  CORRUPT_MSG: 'The link may be corrupted or the page may have been removed.',
  HOME_LINK_LABEL: 'GO BACK TO THE HOMEPAGE',
};
